import { CheckCircle2, ShieldCheck, Users } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const BADGES = [
  { icon: CheckCircle2, top: "Quality", bottom: "Workmanship" },
  { icon: ShieldCheck, top: "Safety", bottom: "First" },
  { icon: Users, top: "Client", bottom: "Focused" },
];

export const QuoteStrip = () => (
  <section className="border-t border-[#1E293B] bg-[#0B0F19]" data-testid="quote-section">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-4 py-14 sm:px-6 lg:flex-row lg:items-center lg:px-8">
      <Reveal>
        <blockquote className="max-w-xl border-l-4 border-[#FF5B00] pl-6 text-lg italic leading-relaxed text-[#F8FAFC] sm:text-xl" data-testid="quote-text">
          &ldquo;Delivering safe, reliable and professional electrical and fiber optic solutions across every
          sector.&rdquo;
        </blockquote>
      </Reveal>
      <div className="flex flex-wrap items-center gap-10">
        {BADGES.map((b, i) => (
          <Reveal key={b.top} delay={i * 0.1}>
            <div className="flex items-center gap-3" data-testid={`badge-${b.top.toLowerCase()}`}>
              <b.icon className="h-9 w-9 text-[#FF5B00]" strokeWidth={1.6} />
              <span className="font-mono-tech text-[11px] font-semibold uppercase leading-snug tracking-[0.15em] text-[#F8FAFC]">
                {b.top}
                <br />
                {b.bottom}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
